import { HttpClient } from '@angular/common/http';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-map-subject',
  templateUrl: './map-subject.component.html',
  styleUrls: ['./map-subject.component.scss']
})
export class MapSubjectComponent implements OnInit {
  filteredmapSubjectList: any;
subject;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService, private httpClient: HttpClient,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<MapSubjectComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private fb: FormBuilder, public router: Router) { }
mapForm:FormGroup;
mapSubjectList:any;
x = sessionStorage.getItem('EsEmId');
 a;
  b;
 c;
@HostListener('document:keyup.escape') onClose() {
  this.onCancel();
}

  ngOnInit(): void {
     this.a=this.data.EsId;
    this.b=this.data.EsMapLEsId;
   // this.c=this.data.EsMapType;
    this.x = sessionStorage.getItem('EsEmId');
    this.mapForm = this.fb.group({ 
      subject:new FormControl(this.data.EsCode),
      optionlCompalsary:new FormControl(''),
      mapto:new FormControl(''), 
    })
    let e =''
    this.getMapSubject(e);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit() {
      let payload =this.data;
       payload['EsId'] = this.a;
       payload['EsMapLEsId'] = this.b;
       payload['EsMapType'] = this.mapForm.value.optionlCompalsary;
      this.umsService.updateMappingSubject(payload).subscribe(res => {
      });
     this.dialogRef.close();
   
  }
  getMapSubject(id){
    const payload = {};
    payload['EsEmId'] = this.x;
    payload['EsStrId'] = 0
      this.umsService.getMapSubject(payload).subscribe(res => {
        this.mapSubjectList = res.data;
        this.filteredmapSubjectList = this.mapSubjectList.slice();
        }
       );
  }


getdata(e){
  this.data=e  
}
}
